/** @format */
import React from 'react'

export default function ViewHeader({ prev, next, titleAction, data }) {
  return (
    <div className="navigation-wrapper">
      <span className="prev" onClick={prev}>
        &lt;
      </span>
      <span className="navigation-title" onClick={titleAction}>
        {data}
      </span>
      <span className="next" onClick={next}>
        &gt;
      </span>
    </div>
  )
}



// WEBPACK FOOTER //
// ./ui/DatePicker/view-header.js